import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

//GET
export const getAllPriceLevels = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "price_levels/get_all_price_level",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error.response };
    }
};

export const getAllPriceLevelsBasedOnItem = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "price_levels/get_all_price_level",
            {
                requester: getUser(),
                token: getToken(),
                has_price: 0,
                item_id: id
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error.response };
    }
};

export const getPriceLevel = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "price_levels/get_price_level",
            {
                requester: getUser(),
                token: getToken(),
                price_level_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error.response };
    }
};

export const searchPriceLevel = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "price_levels/search",
            {
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error.response };
    }
};

export const createPriceLevel = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "price_levels/create",
            {
                requester: getUser(),
                token: getToken(),
                name: data.name,
                description: data.description,
                // names: data.names,
                // commission_rates: data.commission_rates,
                // product_ids_0: data["product_ids_0"],
                // product_ids_1: data["product_ids_1"],
                // product_ids_2: data["product_ids_2"],
                // prices_0: data["prices_0"],
                // prices_1: data["prices_1"],
                // prices_2: data["prices_2"],
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error };
    }
};

export const updatePriceLevel = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "price_levels/update",
            {
                requester: getUser(),
                token: getToken(),
                price_level_id: data.id,
                name: data.name,
                description: data.description,
                // names: data.names,
                // commission_rates: data.commission_rates,
                // product_ids_0: data["product_ids_0"],
                // product_ids_1: data["product_ids_1"],
                // prices_0: data["prices_0"],
                // prices_1: data["prices_1"],
                // product_ids_2: data["product_ids_2"],
                // prices_2: data["prices_2"],
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error };
    }
};

export const deletePriceLevel = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "price_levels/delete",
            {
                requester: getUser(),
                token: getToken(),
                price_level_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        //
        return { error: error };
    }
};
